import { render, staticRenderFns } from "./Direct.vue?vue&type=template&id=0504a56a&scoped=true"
import script from "./Direct.vue?vue&type=script&lang=js"
export * from "./Direct.vue?vue&type=script&lang=js"
import style0 from "./Direct.vue?vue&type=style&index=0&id=0504a56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504a56a",
  null
  
)

export default component.exports